// Status, telefones e vínculo contato <-> progresso nos minicursos.
import { FiCheckCircle, FiClock, FiPauseCircle, FiSend, FiSlash, FiXCircle } from 'react-icons/fi';
import { telefoneDoProgresso, variantesTelefone } from '../relatorios/util';

// Status usados pelo bot e pelos envios (convite -> "1" -> Ativo). Selo sempre com ícone + rótulo.
export const STATUS_CONTATO = [
  { valor: 'Pendente', rotulo: 'Pendente', descricao: 'Aguardando convite', tom: 'warning', icone: FiClock },
  { valor: 'Convidado', rotulo: 'Convidado', descricao: 'Convite enviado, aguardando resposta', tom: 'info', icone: FiSend },
  { valor: 'Ativo', rotulo: 'Ativo', descricao: 'Aceitou o convite e recebe os envios', tom: 'success', icone: FiCheckCircle },
  { valor: 'Recusado', rotulo: 'Recusado', descricao: 'Recusou o convite', tom: 'neutral', icone: FiSlash },
  { valor: 'Saiu', rotulo: 'Saiu', descricao: 'Mandou SAIR e não recebe envios', tom: 'neutral', icone: FiSlash },
  { valor: 'Suspenso', rotulo: 'Suspenso', descricao: 'Envios pausados', tom: 'warning', icone: FiPauseCircle },
  { valor: 'Bloqueado', rotulo: 'Bloqueado', descricao: 'Não recebe envios', tom: 'danger', icone: FiXCircle },
];

export const statusDoContato = (valor) =>
  STATUS_CONTATO.find((s) => s.valor === valor) || { valor, rotulo: valor || 'Sem status', descricao: '', tom: 'neutral', icone: null };

// Gravado como 55 + DDD + número (padrão do cadastro e do bot)
export const telefoneParaSalvar = (digitosNacionais) => `55${String(digitosNacionais).replace(/\D/g, '')}`;

export function telefoneParaEditar(telefone) {
  const d = String(telefone || '').replace(/\D/g, '');
  return d.startsWith('55') && d.length >= 12 ? d.slice(2) : d;
}

export function mascaraTelefone(valor) {
  const d = String(valor || '').replace(/\D/g, '').slice(0, 11);
  if (d.length <= 2) return d ? `(${d}` : '';
  if (d.length <= 6) return `(${d.slice(0, 2)}) ${d.slice(2)}`;
  if (d.length <= 10) return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`;
  return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
}

export const formatarTelefoneContato = (telefone) => mascaraTelefone(telefoneParaEditar(telefone)) || '—';

export function formatarDataSimples(valor) {
  if (!valor) return '—';
  // datas "AAAA-MM-DD" (nascimento) não podem sofrer fuso
  if (/^\d{4}-\d{2}-\d{2}$/.test(valor)) {
    const [a, m, d] = valor.split('-');
    return `${d}/${m}/${a}`;
  }
  const data = typeof valor.toDate === 'function' ? valor.toDate() : new Date(valor);
  return isNaN(data.getTime()) ? '—' : data.toLocaleDateString('pt-BR');
}

// Progresso do contato nos minicursos: pelo ID do WhatsApp gravado na matrícula ou pelo telefone (com e sem o 9)
export function progressosDoContato(contato, progressos) {
  const variantes = variantesTelefone(contato.telefone);
  return progressos.filter((p) =>
    (contato.whatsappId && p.contactId === contato.whatsappId) || variantes.includes(telefoneDoProgresso(p)));
}

// Curso em andamento (o mais recente), se houver
export function cursoAtualDoContato(contato, progressos) {
  return progressosDoContato(contato, progressos)
    .filter((p) => !p.concluido)
    .sort((a, b) => (b.timestampUltimaEtapa?.seconds || 0) - (a.timestampUltimaEtapa?.seconds || 0))[0] || null;
}
